export default __webpack_public_path__ + "static/media/morewine.16f597cd.png";